module.exports = {
	...require('../src/global/logger')
};
